import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useMemo, useRef } from 'react';
import { InternalUser } from '../models/InternalUser';

export interface LaunchDarklyHook {
  identify(user: InternalUser): void;
}

export function useLaunchDarkly(): LaunchDarklyHook {
  const client = useLDClient();
  const clientRef = useRef(client);
  
  // Keep the latest client in ref but don't trigger re-memoization
  if (client) {
    clientRef.current = client;
  }
  
  return useMemo(() => ({
    identify(user: InternalUser): void {
      if (clientRef.current) {
        const roles = user.roles.map((role) => role.name);
        clientRef.current.identify({
          kind: 'user',
          key: user.id,
          roles,
        });
      }
    },
  }), []); // Empty deps - only create once
}
